import React from "react";
import { useFetch, loading } from "../../helpers/hooks.jsx";
import ConcertYear from "./ConcertsYear.jsx";
import "./concertsYearGroup.css";

const ConcertsYearGroup = ({ lang, year }) => {
  const [concerts, loadingConcerts] = useFetch(
    "https://sancta-cecilia.cz/concerts_json.php?year=" + year
  );

  return loadingConcerts ? (
    loading[lang]
  ) : concerts.length > 0 ? (
    <div className="concertYearGroup">
      <ConcertYear lang={lang} year={year} concerts={concerts} />
    </div>
  ) : (
    ""
  );
};

export default ConcertsYearGroup;



// WEBPACK FOOTER //
// ./src/components/Concerts/ConcertsYearGroup.jsx